module.exports = __webpack_public_path__ + "static/desktop/img/photobook-5-thumb.c56fa151.png";